<template lang="pug">
	div
		v-row
			v-col.text-right
				v-btn(
					v-if="validCustomerVehicles && !currentIntegrationIsXtime"
					@click="toggleVehicleForm"
					class="mb-2"
					color="success"
					outlined
					small
				)
					| {{ showVehicleForm ? 'Hide Vehicle Form' : 'New Vehicle' }}
					v-icon(color="success") {{ showVehicleForm ? 'mdi-chevron-up' : 'mdi-plus' }}

		v-row(v-if="!showVehicleForm && validCustomerVehicles")
			v-col(cols='12')
				v-autocomplete(
					v-model="customerVehicleId"
					:items="customerVehicles"
					:item-text="customerVehicleLabel"
					item-value="customer_vehicle_id"
					label="Select Vehicle"
					outlined
					dense
					:rules="[rules.required]"
					required
					@change="handleVehicleChange"
				)
					template(v-slot:item="{ item }")
						span.vehicle-info {{ item.vehicle_model_year || "---"  }} {{ item.vehicle_make || "---" }} {{ item.vehicle_model || "---" }}
						span.spacer
						span.vin-text VIN: {{ item.vin || "---" }}
				
				.vehicle-note
					| Includes only vehicles with a valid VIN, year, make, and model.

		VehicleForm(
			:customer-vehicles="customerVehicles"
			:show-snackbar="showSnackbar"
			:create-customer-vehicle="createCustomerVehicle"
			:show-vehicle-form="showVehicleForm"
			:is-vehicle-saving="isVehicleSaving"
		)
</template>

<script lang="ts">
	import Vue from 'vue';
	import VehicleForm from '@/components/communication_center/shared/tabs/integration/vehicle_form.vue';

	// Data
	import { CreateCustomerVehicle } from "@/data";

	export default Vue.extend({
		data() {
			return {
				customerVehicleId: null,
				isVehicleSaving: false,
				rules: {
					required: (v: any) => !!v || 'Required.',
				},
			}
		},
		methods: {
			createCustomerVehicle(vehicleForm) {
				if (!vehicleForm || !vehicleForm.year || !vehicleForm.make || !vehicleForm.model || !vehicleForm.vin) {
					this.showSnackbar("error", "Unable to create customer vehicle");
					return;
				}

				this.isVehicleSaving = true;

				const options = {
					account_id: this.currentCampaignCustomer?.account_id || 0,
					customer_id: this.currentCampaignCustomer?.customer_id || 0,
					organization_id: this.currentCampaignCustomer?.organization_id || 0,
					campaign_customer_active_id: this.currentCampaignCustomer?.campaign_customer_active_id || 0,
					vehicle_model_year: vehicleForm.year || "",
					vehicle_make: vehicleForm.make || "",
					vehicle_model: vehicleForm.model || "",
					vin: vehicleForm.vin || "",
				}

				CreateCustomerVehicle(options).then((response) => {
					if (response?.Data?.customer_vehicle?.customer_vehicle_id) {
						const vehicle = response.Data.customer_vehicle;
						
						// update customer vehicles in parent component
						this.handleAddCustomerVehicle(vehicle);

						// set new vehicle as selected
						this.setSelectedVehicle(vehicle);

						this.showSnackbar("success", "Vehicle created successfully");
					} else {
						this.showSnackbar("error", "Failed to create vehicle");
					}

					this.isVehicleSaving = false;
					this.handleToggleVehicleForm(false);
				});

			},
			handleVehicleChange() {
				const selectedVehicle = this.customerVehicles.find(v =>
					v.customer_vehicle_id === this.customerVehicleId
				) || null;

				if (selectedVehicle) {
					this.setSelectedVehicle(selectedVehicle);
				};
			},
			toggleVehicleForm() {
				this.handleToggleVehicleForm(!this.showVehicleForm);
			},
		},
		computed: {
			customerVehicleLabel() {
				return (item) => `${item?.vehicle_model_year || "---"} ${item?.vehicle_make || "---"} ${item?.vehicle_model || "---"}`;
			},
			validCustomerVehicles() {
				return this.customerVehicles && this.customerVehicles.length > 0;
			},
			currentIntegrationIsXtime() {
				return this.currentIntegration === "xtime";
			},
		},
		components: {
			VehicleForm,
		},
		props: {
			currentIntegration: String,
			currentCampaignCustomer: Object,
			customerVehicles: Array,
			handleAddCustomerVehicle: Function,
			firstCustomerVehicle: Object,
			selectedVehicle: Object,
			setSelectedVehicle: Function,
			showSnackbar: Function,
			handleToggleVehicleForm: Function,
			showVehicleForm: Boolean,
		},
		created() {
			if (!this.validCustomerVehicles) {
				this.handleToggleVehicleForm(true);
			}

			// set customer vehicle id
			this.customerVehicleId = this.selectedVehicle?.customer_vehicle_id || this.firstCustomerVehicle?.customer_vehicle_id || null;
		},
		watch: {
			selectedVehicle: {
				handler(newValue) {
					if (newValue) {
						this.customerVehicleId = newValue.customer_vehicle_id;
					}
				},
				immediate: true,
				deep: true,
			},
		},
	})
</script>

<style lang="scss" scoped>
.vin-text {
	color: #999;
	font-size: 0.85em;
	font-weight: normal;
}

.vehicle-info {
	color: var(--volie-blue);
	font-weight: bold;
}

.vehicle-note {
	color: var(--volie-blue);
	font-size: 0.875rem;
}
</style>